export const CSS = {
  actions: "actions",
  actionsEnd: "actions--end",
  actionsStart: "actions--start",
  description: "description",
  handle: "handle",
  handleActivated: "handle--activated",
  highlight: "highlight",
  icon: "icon",
  iconDot: "icon-dot",
  label: "label",
  remove: "remove",
  title: "title",
  textContainer: "text-container",
};

export const ICONS = {
  checked: "check",
  remove: "x",
};

export const SLOTS = {
  actionsEnd: "actions-end",
  actionsStart: "actions-start",
};
